import React, { useState, useContext } from 'react'
import { CategoriesContext, LawyerContext } from '../../../../partials/Context';
import getCookie from '../../../../partials/cookie';
import { Errors } from '../../../../partials/Partials';

function EditCaseForm({getCurrentLawyer, caseId, description, setDescription, category, setCategory, tags, setTags, setDisplayEditForm}) {
    const categories = useContext(CategoriesContext);
    const lawyer = useContext(LawyerContext);
    const {id} = lawyer || '';
    const [errors, setErrors] = useState([]);

    const {prywatne, firmowe} = categories || [];
    let prywatne_list = [];
    let firmowe_list = [];

    if (prywatne) {
        prywatne.map(item => {
            prywatne_list.push(
                <option key={item.id} value={item.id}>{item.name}</option>
            )
            return prywatne_list
        })
    }

    if (firmowe) {
        firmowe.map(item => {
            firmowe_list.push(
                 <option key={item.id} value={item.id}>{item.name}</option>
            )
            return firmowe_list
        })
    }

    const editCase = (e) => {
        e.preventDefault();
        const csrftoken = getCookie('csrftoken');

        const payload = {
            id: caseId,
            description: e.target.querySelector('#description').value,
            category: e.target.querySelector('#category').value,
            tags: e.target.querySelector('#case_tags').value,
            lawyer: id,
        }

        fetch('/api/lawyer_profiles_extended/current/update_case/', {
            method:'PUT',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                ...payload
            })
        }).then(res => {
            if (res.ok) {
                e.target.querySelector('#description').value = ''
                e.target.querySelector('#category').value = null
                e.target.querySelector('#case_tags').value = ''
                setErrors([])
                setDisplayEditForm(false)
                getCurrentLawyer()
            } else {
                setErrors(['Nie udało się zmienić sprawy'])
            }
        })
    }

    const deleteCase = (e) => {
        e.preventDefault();
        if (!window.confirm('Chcesz usunąć daną sprawę: ' + e.target.parentElement.parentElement.querySelector('#description').value)) {
            return;
        };
        const csrftoken = getCookie('csrftoken');
        const payload = {
             id: caseId,
        }

        fetch('/api/lawyer_profiles_extended/current/delete_case/', {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                ...payload
            })
        }).then(res => {
            if (res.ok) {
                setErrors([])
                setDisplayEditForm(false)
                getCurrentLawyer()
            } else {
                setErrors(['Nie udało się usunąć sprawy'])
            }
        })
    }

    return (
    <form onSubmit={(e) => editCase(e)} id="edit-case-form">
        <Errors errors={errors} />
        <div className="form-group">
            <label className="col-sm-3 control-label">Opis sprawy: </label>
            <div className="input-field">
                <textarea id="description" placeholder="Wpisz np.: wygrana sprawa o zasądzenie zaległego wynagrodzenia i premii pracownika działu sprzedaży firmy farmaceutycznej" maxLength="2048" required="required" text-area-autosize=""
                value={description} onChange={e => setDescription(e.target.value)}/>
                <div className="help-block">
                    Krótki opis sprawy w jednym lub dwóch zdaniach.
                    Nie umieszczaj ogólników, lecz konkretny przykład sprawy.
                    Klienci szukają tu opisów spraw podobnych do swojej.
                </div>
            </div>
        </div>
        <div className="form-group">
            <label className="col-sm-3 control-label">Kategoria: </label>
            <div className="input-field">
                <select required="required" id="category" value={category} onChange={e => setCategory(e.target.value)}>
                    <option style={{color: '#ccc'}}>wybierz kategorię problemu prawnego</option>
                    <optgroup label="Prywatna">
                        {prywatne_list}
                    </optgroup>
                    <optgroup label="Firmowa">
                        {firmowe_list}
                    </optgroup>
                </select>
            </div>
        </div>
        <div className="form-group">
            <label className="col-sm-3 control-label" htmlFor="case_tags">
                Słowa kluczowe:
                <div className="help-block">oddzielone przecinkiem<br/>opcjonalne</div>
            </label>
            <div className="input-field">
                <input id="case_tags" type="text" maxLength="100" placeholder="np. pozew, spółki akcyjne, przygotowanie umów" value={tags} onChange={e => setTags(e.target.value)}/>
            </div>
        </div>
        <div className="form-group">
            <button className="btn btn-primary" type="submit">Zmień</button>
            <button className="btn btn-danger" type="button" onClick={deleteCase}>Usuń</button>
        </div>
        <hr />

    </form>
    )
}

export default EditCaseForm